import { ApiService, GenericError} from './api-main';
import { f7 } from 'framework7-vue';

const MiscService = {
    getNearestOutlet: async function() {
        const url = 'main/merchant/location?merchantId=2&retailAgentId=24'

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            console.log(response)
            return ApiService.validateResponse(response, '9800')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getNearestMtm: async function() {
        const url = 'main/mtm/location'
        const params = {
            retailAgentId : process.env.VUE_APP_RETAIL_AGENT_ID
        }
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            console.log(response)
            return ApiService.validateResponse(response, '3202')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getNearestP2hOutlet: async function() {
        const url = 'main/retail/'+process.env.VUE_APP_RETAIL_AGENT_ID+'/location'
        
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            console.log(response)
            return ApiService.validateResponse(response, '3200')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },
    getVersionApp: async function() {
        const url = 'main/version/current'
        
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            console.log(response)
            return ApiService.validateResponse(response, '20000')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },
    checkDeviceRedirect: (deviceInfo) => {
        const ua = window.navigator.userAgent
        const dvc = typeof deviceInfo !== 'undefined' ? deviceInfo : f7.device ;
        let appRedirPath = ""

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        //console.log("PARAMS : "+queryString);

        const allowMobile = urlParams.get('mb')
        console.log("QUERY isAllowMobile : ", allowMobile);

        let isAllowMobile = false;
        if(allowMobile && allowMobile.trim() != ""){
            if(allowMobile == "true"){
                isAllowMobile = true;
                console.log("allow open mobile browser")
            }else{
                console.log("allow mobile browser's param defined with value : "+allowMobile)
            }
        }else{
            console.log("QUERY allowMobile NOT DEFINED ");
        }

        console.log("isAllowMobile : "+isAllowMobile)

        if(!dvc.desktop && !isAllowMobile){
          if(dvc.ios) {
            if(!dvc.webView){
              appRedirPath = process.env.VUE_APP_IOS_REDIR_URL
            }
          } else if (dvc.android) {
            let uaLow = ua.toLowerCase()
            if ( !(!!~(uaLow.indexOf("wv")) || !!~(uaLow.indexOf("vw"))) ) {
              appRedirPath = process.env.VUE_APP_AOS_REDIR_URL
            }
          }
        }
        return appRedirPath
    },

    //note: this api is at marketing
    getServiceTime: async function() {

        const requestData = {
            method: 'get',
            url: 'marketingurl/api/servicetime' 
        }

        try {
            const response = await ApiService.customRequest(requestData)
          
            return response;
        } catch (e) {
            if (e instanceof GenericError) {
                throw e
            }
        }
    },

    // for testing connection only
    ping: async function() {
        try {
            const response = await ApiService.ping()
          
            return response;
        } catch (e) {
            if (e instanceof GenericError) {
                throw e
            }
        }
    },
}

export default MiscService